import React from "react";

import { data, dataHora, reais } from "../comum/formato";

function Linha({ rotulo, valor }) {
  return (
    <div className="flex justify-between gap-3 py-1.5 border-b last:border-0 text-sm">
      <span className="text-muted-foreground">{rotulo}</span>
      <span className="font-medium text-right">{valor}</span>
    </div>
  );
}

export default function RegrasPromocao({ promocao: p }) {
  if (p.tipo === "nao_identificada") {
    return <section className="rounded-xl border bg-card p-4 sm:p-5 text-sm text-muted-foreground">{p.descricao}</section>;
  }
  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="regras-promocao">
        <h3 className="font-semibold mb-2">{p.tipo === "de_por" ? "Preço riscado do produto" : "Como a promoção funciona"}</h3>
        {p.tipo === "promocao" && p.existe ? (
          <>
            <Linha rotulo="Dias" valor={p.dias_semana?.length ? p.dias_semana.join(", ") : "Todos os dias"} />
            <Linha rotulo="Horário" valor={p.horario || "O dia todo"} />
            <Linha rotulo="Validade" valor={p.valido_de || p.valido_ate ? `${p.valido_de ? data(p.valido_de) : "desde a criação"} até ${p.valido_ate ? data(p.valido_ate) : "sem fim"}` : "Sem prazo"} />
            <Linha rotulo="Onde vale" valor={p.modulos?.length ? p.modulos.join(", ") : "Todos os módulos"} />
            <Linha rotulo="Aceita cupom" valor={p.aceita_cupom ? "Sim" : "Não"} />
            <Linha rotulo="Limite de usos" valor={p.limite_usos ? `${p.usos_contados} de ${p.limite_usos}` : `Sem limite (${p.usos_contados} contados)`} />
            <Linha rotulo="Criada em" valor={dataHora(p.criada_em)} />
          </>
        ) : p.tipo === "promocao" ? (
          <p className="text-sm text-muted-foreground">A promoção foi excluída. As vendas guardadas no pedido continuam aqui.</p>
        ) : (
          <p className="text-sm text-muted-foreground">Produto com "preço de" cadastrado acima do preço de venda: aparece riscado no cardápio.</p>
        )}
      </section>
      <section className="rounded-xl border bg-card p-4 sm:p-5">
        <h3 className="font-semibold mb-2">Preços hoje</h3>
        {(p.produtos || []).length === 0 ? <p className="text-sm text-muted-foreground">Sem produtos.</p> : (
          <ul className="divide-y">
            {p.produtos.map((it, i) => (
              <li key={i} className="flex items-center justify-between gap-3 py-2 text-sm">
                <span className="truncate">{it.produto}{it.sizes ? <span className="text-xs text-muted-foreground"> (por tamanho)</span> : null}</span>
                <span className="tabular-nums shrink-0">
                  {it.cheio ? <span className="text-muted-foreground line-through mr-2">{reais(it.cheio)}</span> : null}
                  <b className="text-emerald-600 dark:text-emerald-400">{it.promo ? reais(it.promo) : "—"}</b>
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
